import { CommonContext } from '@repo-level/core-front';
import { RealTimeServiceContext } from 'contexts/realTimeService';
import { amountWithCurrencySymbolString } from 'helpers/currency';
import { showTooltip } from 'helpers/tooltip';
import { getCurrencyCentsAndCode } from 'helpers/wallet';
import { TooltipTypes } from 'modules/globalTooltip';
import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const usePaymentNotification = () => {
  const { t } = useTranslation('deposits');

  const { playerPayments } = useContext(RealTimeServiceContext);

  const { currencies } = useContext(CommonContext);

  useEffect(() => {
    if (playerPayments.length === 0) return;

    const lastPayment = playerPayments[playerPayments.length - 1];

    if (!lastPayment.success) return;

    const { currency, amount } = getCurrencyCentsAndCode(
      lastPayment.amountCents,
      lastPayment.currency,
      currencies
    );

    showTooltip({
      type: TooltipTypes.SUCCESS,
      title: '',
      text: t('paymentSuccessful', {
        amount: amountWithCurrencySymbolString(currency, amount),
      }),
    });
  }, [currencies, playerPayments, t]);
};
